<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <div>
        <el-form-item label="申请日期">
          <el-date-picker
            v-model="formInline.withdrawDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="true"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="总代名称" v-if="userType === 'admin'">
          <el-select
            v-model="formInline.agentid"
            placeholder="请选择"
            @change="handleChangeAgent"
          >
            <el-option
              v-for="(item, index) in agentList"
              :key="index"
              :label="item.agentName"
              :value="item.agentid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加盟商名称" v-if="userType === 'admin'">
          <el-select v-model="formInline.vendorid" placeholder="请选择">
            <el-option
              v-for="(item, index) in vendorList"
              :key="index"
              :label="item.vendorName"
              :value="item.vendorid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </div></el-form
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        prop="agentName"
        label="总代名称"
        width="100px"
      ></el-table-column>
      <el-table-column prop="vendorName" label="加盟商"></el-table-column>
      <el-table-column label="账期" width="240px">
        <template slot-scope="scope">
          {{ scope.row.withdrawBeginDate }}~
          {{ scope.row.withdrawEndDate }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="提现金额">
        <template slot-scope="scope">
          <el-tag
            effect="dark"
            size="medium"
            color="#D46D6A"
            style="color: white; border-color: #FFAAAA;font-size: larger;"
            >{{ scope.row.amount }}</el-tag
          >
        </template></el-table-column
      >
      <el-table-column prop="message" label="留言"></el-table-column>
      <el-table-column prop="stateName" label="状态" width="80px">
        <template slot-scope="scope">
          <el-tag
            :type="getStatusName(scope.row.status)[1]"
            effect="dark"
            size="mini"
            >{{ getStatusName(scope.row.status)[0] }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="createtime" label="申请时间" width="180px">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作人"
        width="100px"
      ></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button type="text" @click="handleShowRemarkDialog(scope.row)">
            备注</el-button
          >
          <el-button
            type="text"
            @click="handleStatus(scope.row, 1)"
            v-if="scope.row.status != 9"
          >
            通过</el-button
          >
          <el-button
            type="text"
            @click="handleStatus(scope.row, 2)"
            v-if="scope.row.status != 9"
            >拒绝</el-button
          >
          <el-button
            type="text"
            @click="handleStatus(scope.row, 9)"
            v-if="scope.row.status != 9"
            >打款完成</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <el-dialog title="收货地址" :visible.sync="showRemarkDialog">
      <div>
        <el-form>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="currentSelected.remark"
              :rows="2"
              placeholder="请输入备注"
              maxlength="180"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showRemarkDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      formInline: {
        withdrawDate: [moment().subtract(30, "days"), moment().add(1, "days")],
        agentid: "",
        vendorid: "",
        shopid: ""
      },
      tableData: [],
      remark: "",
      // currentId: 0,
      currentSelected: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      vendorList: [],
      agentList: [],
      userType: this.$getUserType(),
      showRemarkDialog: false
    };
  },

  methods: {
    onSubmit() {
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        createtimeFrom: this.formInline.withdrawDate
          ? this.$ToDateTimeString(this.formInline.withdrawDate[0])
          : null,
        createtimeTo: this.formInline.withdrawDate
          ? this.$ToDateTimeString(this.formInline.withdrawDate[1])
          : null,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询提现申请"], {
        data: queryModel
      }).then(result => {
        console.log(result);
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },

    handleChangeAgent() {
      console.log(this.formInline.agentid);
      this.formInline.vendorid='';
      if (this.formInline.agentid != "") {
        this.queryVendor(this.formInline.agentid);
      } else {
        this.vendorList = [];
        this.shopList = [];
      }
    },

    handleShowRemarkDialog(row) {
      this.currentSelected = row;
      this.showRemarkDialog = true;
    },
    queryAgent() {
      this.$axios(this.$urlMapping["查询代理商"], {
        data: {}
      }).then(result => {
        this.agentList = [{ agentid: "", agentName: "全部" }, ...result.data];
      });
    },
    queryVendor(agentid) {
      console.log(agentid);
      this.$axios(this.$urlMapping["查询加盟商"], {
        data: { agentid: agentid }
      }).then(result => {
        this.vendorList = [
          { vendorid: "", vendorName: "全部" },
          ...result.data
        ];
      });
    },
    saveRemark() {
      this.$axios(this.$urlMapping["保存提现备注"], {
        data: this.currentSelected
      }).then(res => {
        console.log(res);
        this.showRemarkDialog = false;
        this.onSubmit();
      });
    },
    handleStatus(row, status) {
      console.log(row);
      let statusName = this.getStatusName(status)[0];

      this.$confirm("是否更改状态为【" + statusName + "】?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios(this.$urlMapping["提现审核"], {
            data: { id: row.id, status: status }
          }).then(() => {
            this.onSubmit();
          });
        })
        .catch(() => {});
    },

    getStatusName(status) {
      console.log(status);
      switch (status) {
        case 0:
          return ["申请中", "info"];
        case 1:
          return ["审核通过", "primary"];
        case 2:
          return ["审核拒绝", "danger"];
        case 9:
          return ["已打款", "success"];
        default:
          return ["异常", "danger"];
      }
    }
  },

  async mounted() {
    await this.queryAgent();
    this.onSubmit();
  }
};
</script>

<style></style>
